
import Link from 'next/link';
import Text from '../../components/LanguageResolver';

export default function PlayIndex() {
    
        return (
            <div className='dummy'>
                <h1><Text val="navbar.play"/></h1>
                <br></br>
                <Link href="/play/dice">
                    <p><Text val="play.dice"/></p>
                </Link>
                <span className='vert'></span>
                <Link href="/play/live">
                    <p>Live Chart sync to server test</p>
                </Link>
            </div>
        )
}